module.exports = __webpack_public_path__ + "img/130008.09639691.png";